export const DOMAIN = 'dsarRequestDetails.conversation';
